import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Fully neutralise the benign "ResizeObserver loop ..." browser warning so the
// CRA dev error overlay never covers the UI / blocks clicks (triggered by Radix
// Select/Dialog re-measuring). Two layers:
//  1) debounce ResizeObserver callbacks with rAF so the loop can't escalate to an error;
//  2) capture-phase error listener (runs before react-error-overlay's) as a fallback.
const RO_MSG = "ResizeObserver loop";
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class extends NativeRO {
    constructor(callback) {
      let raf = 0;
      super((entries, observer) => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}
window.addEventListener("error", (e) => {
  if (e && typeof e.message === "string" && e.message.includes(RO_MSG)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
